'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBemReact = require('@yandex-lego/i-bem-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBemReact.decl)({
    block: 'spin2',
    mods: function mods(_ref) {
        var size = _ref.size,
            progress = _ref.progress,
            position = _ref.position,
            view = _ref.view,
            tone = _ref.tone;

        return { size: size, view: view, tone: tone, position: position, progress: (0, _iBemReact.bool2string)(progress) };
    }
}, {
    propTypes: {
        view: _propTypes2.default.string,
        tone: _propTypes2.default.string,
        size: _propTypes2.default.oneOf(['xxs', 'xs', 's', 'm', 'l']),
        progress: _propTypes2.default.bool,
        position: _propTypes2.default.oneOf(['center'])
    },
    defaultProps: {
        view: 'default',
        tone: 'default'
    }
});